const $ = window.jQuery;

const prevArrow = `<button class="slick-prev slick-arrow">
	<svg viewBox="0 0 16 24">
		<path d="M13,2 L3,12 L13,22" stroke="#574684" stroke-width="4" stroke-linecap="round" fill="none"/>
	</svg>
</button>`;

const nextArrow = `<button class="slick-next slick-arrow">
	<svg viewBox="0 0 16 24">
		<path d="M3,2 L13,12 L3,22" stroke="#574684" stroke-width="4" stroke-linecap="round" fill="none"/>
	</svg>
</button>`;

$( '.hero-product-slider' ).slick( {
	arrows       : true,
	slidesToShow : 1,
	mobileFirst  : true,
	prevArrow    : prevArrow,
	nextArrow    : nextArrow,
	responsive   : [
		{
			breakpoint : 768,
			settings   : {
				slidesToShow: 1,
			}
		},
		{
			breakpoint : 992,
			settings   : {
				slidesToShow: 3,
			}
		}
	]
} );
